/* 🤖 this file was generated by script */
export const wiconSend03 = {
  name: 'send_03',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.5 12H5m-.08.3l-2.34 6.97c-.18.54-.27.82-.2.99a.5.5 0 00.32.3c.18.05.44-.07.97-.31l16.7-7.52c.52-.23.78-.35.86-.5a.5.5 0 000-.45c-.08-.16-.34-.28-.85-.5L3.66 3.74c-.52-.24-.79-.36-.96-.3a.5.5 0 00-.33.3c-.07.16.02.43.2.98l2.35 7.06.05.18a.5.5 0 010 .13c0 .05-.02.1-.05.2z"/></svg>`,
};
